module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (2).be3eb242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (2).jpg
// module id = 341
// module chunks = 0